import React, { useContext, useEffect, useState } from 'react'
import SeeIfConflictBtn from './SeeIfConflictBtn'
import ConflictModal from 'Modals/ConflictModal';
import { getCaseType } from 'Utils';
import { casesStatusUpdateApi, conflictToViewApi, noConflictToViewApi, raiseNotificationApi } from 'Constants';
import { Context } from 'Context/Context';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function CheckForConflictOnProfContent({attorney, onClose, setUpdateComp, setRefreshList, setCloseMsg, caseDetails, setUpdateCaseDets, updateCaseResponse}) {
    const [showModal, setShowModal] = useState(false);
    const {userDetails, makeApiCallFunc, setUserDetails} = useContext(Context);
    const navigate = useNavigate();
    const userInfo = attorney? attorney.userId : userDetails;
    useEffect(() => {
        console.log("caseDetails in check for conflict", caseDetails);
    },[])
    const noConflict = () => {
        const owner = caseDetails?.owner;
        const id = caseDetails?._id;
        
        makeApiCallFunc(
            casesStatusUpdateApi,
            {
                caseId: id,
                userId: userInfo._id,
                assistantId: attorney ? userDetails._id : null,
                caseStatus:"noConflict"
            },
            ({data}) => {
                setShowModal(false);
                setRefreshList(true);
                setCloseMsg(caseDetails?.caseNumber + " moved to my Cases successfully.");
                const fullname = attorney ? attorney?.userId?.firstName +" "+ attorney?.userId?.lastName : userDetails?.firstName+" "+userDetails.lastName;
                const notificationObj = {
                    title : "Congratulations, Your case is being viewed by "+ fullname
                    ,
                    is_read : false,
                    sender: "professional",
                    type: "3",
                    receiver:  owner,
                    caseNumber: caseDetails?.caseNumber,
                    notificationCategory: 1,
                    additionalInfo : {
                        "caseId": id,
                        "userId": userDetails._id
                    },
                    content: 
                    userDetails?.role === 5 ?
                    "The Law firm case manager "+ userDetails?.firstName +" "+ userDetails?.lastName +" has indicated that they do not have any conflicts with regard to potentially representing you in this "+getCaseType(caseDetails?.caseType)+ "-" + caseDetails?.caseNumber+".  The law firm will now view your case details."
                    :
                    userInfo?.isUserFunder ?
                    "The litigation funder "+ userDetails?.company +" has indicated that they do not have any conflicts with regard to potentially funding the representation of your "+getCaseType(caseDetails?.caseType)+ "-" + caseDetails?.caseNumber+".  The litigation funder will now view your case details."
                    :
                    attorney ?
                    "The attorney "+ attorney?.userId?.firstName +" "+ attorney?.userId?.lastName +" has indicated that they do not have any conflicts with regard to potentially representing you in this "+getCaseType(caseDetails?.caseType)+ "-" + caseDetails?.caseNumber+".  The attorney will now view your case details."
                    :
                    "The attorney "+ userDetails?.firstName +" "+ userDetails?.lastName +" has indicated that they do not have any conflicts with regard to potentially representing you in this "+getCaseType(caseDetails?.caseType)+ "-" + caseDetails?.caseNumber+".  The attorney will now view your case details."
                }
                updateCaseResponse ?
                updateCaseResponse(id)
                :
                setUpdateCaseDets(prev => !prev);
                raiseNotification(notificationObj);
            },
            (data) => {
        setShowModal(false);
        console.log(data)
        }
        )
    }
    const raiseNotification = (notificationObj) => {
       
        makeApiCallFunc(
            raiseNotificationApi, 
            notificationObj, 
             (data) => {
                console.log(data);
             },
             (error) => console.log(error)
            )
    }
    const onConflict = () => {
        const owner = caseDetails?.owner;
        const id = caseDetails?._id;
        const caseType = caseDetails?.caseType;
       
        makeApiCallFunc(
            casesStatusUpdateApi,
            {
                userId: userInfo?._id,
                caseId: id,
                assistantId: attorney ? userDetails._id : null,
                caseStatus: "conflict"
            },
            (data) => {
                setShowModal(false);
                // setCloseMsg(caseDetails?.caseNumber + " removed from your list due to conflict.");
                toast.info(caseDetails?.caseNumber + " removed from your list.");
                 const userType = userInfo?.isUserFunder ? "Litigation funder" : "Attorney";
                const notificationObj = {
                    title : userType + " removed from case " + getCaseType(caseDetails?.caseType) + " " + caseDetails.caseNumber,
                    is_read : false,
                    sender: "professional",
                    notificationCategory: 1,
                    caseNumber: caseDetails?.caseNumber,
                    type: "4",
                    receiver:  owner,
                    additionalInfo : {
                        "caseId": id,
                        "userId": userInfo._id
                    },
                    content: "Unfortunately, the "+userType+" "+userInfo?.firstName+" "+userInfo.lastName+" is no longer interested in this case. You may continue to seek other "+userType+"s available for your case."
                }
                console.log(notificationObj);
                raiseNotification(notificationObj);
                onClose();
                setUpdateComp(prev => !prev)
                
            
                // setRefreshList(true);
                // updateCaseResponse ?
                // updateCaseResponse(id)
                // :
                // setUpdateCaseDets(prev => !prev);
            },
            (data) => {
                setShowModal(false);
                console.log(data)
            },
        )
    }
  return (
        <>
            {
                showModal &&
                <ConflictModal
                uploadNew={showModal}
                caseDetails={caseDetails}
                onClose={() => setShowModal(false)}
                noConflict={noConflict}
                onConflict={onConflict}
                />
            }
            <div>Waiting for your conflict clearance..<br/><br/>You have been approved. Conflict clearance has to be made to progress to the next step. Find out the parties involved and confirm by doing conflict clearance check in your firm.
                <div className='mt-4'>
                <SeeIfConflictBtn onViewMore={() =>  setShowModal(true)}/>
                </div>
            </div>
            
        </>
        
  )
}

export default CheckForConflictOnProfContent